"use client"

import { useQuery } from '@tanstack/react-query';
import { NuisibleFilters, NuisibleService } from '../../../lib/api/services/nuisible.service';

const nuisibleService = new NuisibleService();

export function useNuisibles(params: NuisibleFilters = {}) {
  const {
    page = 1,
    limit = 10,
    sortBy = 'recent',
    ...rest
  } = params;

  return useQuery({
    queryKey: ['nuisibles', params],
    queryFn: () => nuisibleService.getNuisibles({ page, limit, sortBy, ...rest }),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}